export default __webpack_public_path__ + "static/media/fsta2017.68584860.png";